// extracted by mini-css-extract-plugin
export var disabled = "_q4-0";